import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPaste = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M8.988 10.187a2.75 2.75 0 0 1 2.75-2.75h3.19a2.75 2.75 0 0 1 2.75 2.75v4.628a2.75 2.75 0 0 1-2.75 2.75h-3.19a2.75 2.75 0 0 1-2.75-2.75zm2.75-1.25c-.69 0-1.25.56-1.25 1.25v4.628c0 .69.56 1.25 1.25 1.25h3.19c.69 0 1.25-.56 1.25-1.25v-4.628c0-.69-.56-1.25-1.25-1.25z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M4.755 4.717a1.25 1.25 0 0 0-.923 1.207v7.604c0 .69.56 1.25 1.25 1.25h2.342v1.5H5.082a2.75 2.75 0 0 1-2.75-2.75V5.924a2.75 2.75 0 0 1 2.385-2.726c.259-.48.767-.807 1.351-.807h4.028c.577 0 1.08.318 1.342.79a2.58 2.58 0 0 1 2.394 2.575h-1.5c0-.538-.392-.984-.906-1.068-.265.46-.761.77-1.33.77H6.068a1.53 1.53 0 0 1-1.313-.741m.78-.793c0-.295.238-.533.533-.533h4.028a.534.534 0 0 1 0 1.067H6.068a.533.533 0 0 1-.533-.534m5.889 6.909a.5.5 0 0 1 .5-.5h2.913a.5.5 0 0 1 0 1h-2.913a.5.5 0 0 1-.5-.5m0 1.907a.5.5 0 0 1 .5-.5h1.456a.5.5 0 1 1 0 1h-1.456a.5.5 0 0 1-.5-.5"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPaste;
